const productIdToDetails = {
    1: {name: "Fall Limited Edition Sneakers", price: 125, thumbnail: "image-product-1-thumbnail.jpg"},
}

const state = {
    _curSelected: 1,
    _onCurSelectedChangedCallbacks: [],
    setCurrentSelected(num) {
        this._onCurSelectedChangedCallbacks.forEach(cb => {
            cb(num)
        });
        this._curSelected = num;
    },
    get currentSelected() {
        return this._curSelected;
    },
    addCurrentSelectedChangedCallback(cb) {
        this._onCurSelectedChangedCallbacks.push(cb);
    },

    mainGallery: null,
    lightboxGallery: null,

    cartItems: [],
    _cartItemsChangedCallbacks: [],
    addCartItem(count, id = 1) {
        let cartItem = {
            id,
            count,
            ...productIdToDetails[id],
            get totalPrice() {
                return this.price * this.count
            }
        };

        // now only 1 item no need to get complex
        if (this.cartItems.length !== 0) {
            const oldItem = this.cartItems[0]
            cartItem.count+= oldItem.count
            this.cartItems = []
        }

        this.cartItems.push(cartItem)
        this._cartItemsChangedCallbacks.forEach(cb => {
            cb(this.cartItems)
        });
    },
    removeCartItem(id = 1) {
        this.cartItems = []
        this._cartItemsChangedCallbacks.forEach(cb => {
            cb(this.cartItems)
        });
    },
    addCartItemsChangedCallback(cb) {
        this._cartItemsChangedCallbacks.push(cb);
    },
}

const galleryState = (globalState) => {
    return {
        _galleryCurrentActiveIndex: 1,
        _galleryMaxIndex: 4,
        _onGalleryIndexChangedCallbacks: [],
        setGalleryActiveIndex(index) {
            const prevIndex = this._galleryCurrentActiveIndex;
            this._galleryCurrentActiveIndex = index;
            this._onGalleryIndexChangedCallbacks.forEach(cb => {
                cb(index, prevIndex)
            });
        },
        get galleryCurrentActiveIndex() {
            return this._galleryCurrentActiveIndex;
        },
        addGalleryIndexChangedCallback(cb) {
            this._onGalleryIndexChangedCallbacks.push(cb);
        }
    }
}

state.mainGallery = galleryState(state)
state.lightboxGallery = galleryState(state)

console.log("State:", state)
export default state;